import { Feature } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { Gebaeude, Outbuilding } from '../../../store/reducers/gebaeude.reducer';
import { ResidentialUnits } from '../../../store/models';
import { selectIsErsatzgeschaeft, selectIsNeugeschaeft } from './vertragsoption.selector';
import { selectIsAzamUnderwriter } from './transient-state.selector';

export const selectGebaeude = (state: IAppState): Gebaeude => state.gebaeude;

export const selectNebengebaeude = (state: IAppState): Outbuilding =>
  state.gebaeude.nebengebaeude;

export const isNebengebaeudeVorhanden = (state: IAppState): string =>
  state.gebaeude.nebengebaeude.available === null
    ? null
    : String(state.gebaeude.nebengebaeude.available);

export const baujahr = (state: IAppState): number =>
  state.gebaeude ? state.gebaeude.baujahr : null;

export const wohnflaeche = (state: IAppState): number =>
  state.gebaeude ? state.gebaeude.wohnflaeche : null;

export const selectResidentialUnits = (state: IAppState): ResidentialUnits | null =>
  state.gebaeude ? state.gebaeude.wohneinheiten : null;

export const isDenkmalschutzSelectableByValue = (dasBaujahr: number): boolean =>
  dasBaujahr !== null && dasBaujahr <= 1980;

export const isGebaeudeYoungerThanFiveYears = (dasBaujahr: number): boolean =>
  dasBaujahr != null && new Date().getFullYear() - dasBaujahr < 5;

export const isDenkmalschutzSelectable = (state: IAppState): boolean =>
  isDenkmalschutzSelectableByValue(state.gebaeude.baujahr);

export const isSchwimmbadSelectableByValue = (wohnflache: number): boolean =>
  wohnflache != null && wohnflache > 99;

export const isSchwimmbadSelectable = (state: IAppState): boolean =>
  isSchwimmbadSelectableByValue(state.gebaeude.wohnflaeche);

export const isFeuerrohbauSelectable = (state: IAppState): boolean =>
  !selectIsErsatzgeschaeft(state);

export const isOutbuildingTotalAreaGreaterThan200sqm = (state: IAppState): boolean =>
  state.gebaeude.nebengebaeude.totalArea > 200;

export const isOutbuildingTotalAreaValid = (state: IAppState): boolean =>
  !isOutbuildingTotalAreaGreaterThan200sqm(state) || !selectIsNeugeschaeft(state) || selectIsAzamUnderwriter(state);

export const selectVwgWohneinheitenToggle = (state: IAppState): boolean =>
  state.transientState.featureToggles?.[Feature.VWG_WOHNEINHEITEN] ?? false;

export const isNebengebaeudeLeistungSelectable = (state: IAppState): boolean => {
  const uwNebengebaeudeToggleActive =
    state.transientState.featureToggles?.[Feature.UW_NEBENGEBAEUDE] ?? false;
  return uwNebengebaeudeToggleActive || isOutbuildingTotalAreaValid(state);
};

export const isNewConstruction = (state: IAppState): boolean => {
  const buildingYear = state.gebaeude?.baujahr;
  const currentYear = new Date().getFullYear();

  return buildingYear != null && buildingYear >= currentYear;
};
